import { Form } from "antd";
import type { FC } from "react";
import { useTranslation } from "react-i18next";

import type { ManualDasConfigurationEntity } from "src/app/features/ManualDasConfiguration/types/ManualDasConfigurationEntity";
import { Checkbox, SelectDynamic } from "../../../../../components/Form/formComponents";
import type { SearchFormProps } from "../../../../../components/Form/types/types";
import { acquirerProviderSelectConfig, siteGroupsSelectConfig } from "../../../../../components/SearchForm/FormSearchUtils";
import { SearchForm } from "../../../../../components/SearchForm/SearchForm";

export const ManualDasConfigurationSearchForm: FC<SearchFormProps<ManualDasConfigurationEntity>> = ({ searchCallback }) => {
    const { t } = useTranslation();

    return (
        <SearchForm searchCallback={searchCallback}>
            <Form.Item name="siteId" label={t("orgUnitsSearchForm.parentSiteName")}>
                <SelectDynamic name="siteId" label={t("")} fieldConfig={siteGroupsSelectConfig} />
            </Form.Item>
            <Form.Item name="acquirer" label={t("hostProductCodeCreateForm.acquirer")}>
                <SelectDynamic name="acquirer" label={t("hostProductCodeCreateForm.acquirer")} fieldConfig={acquirerProviderSelectConfig} />
            </Form.Item>
            <Form.Item label={t("manualDasConfigs.disabledForDas")} name="disabledDas" valuePropName="checked">
                <Checkbox name="disabledDas" label="" readOnly={false} defaultChecked={false} />
            </Form.Item>
        </SearchForm>
    );
};
